import { getEventType } from './utils';
var PREFIX = 'xstate';
// xstate-specific action types
export var actionTypes = {
    start: PREFIX + ".start",
    stop: PREFIX + ".stop",
    raise: PREFIX + ".raise",
    send: PREFIX + ".send",
    cancel: PREFIX + ".cancel",
    null: PREFIX + ".null"
};
var createActivityAction = function (actionType) { return function (activity) {
    var data = typeof activity === 'string' || typeof activity === 'number'
        ? { type: activity }
        : activity;
    return {
        type: actionType,
        activity: getEventType(activity),
        data: data
    };
}; };
export var toEventObject = function (event) {
    if (typeof event === 'string' || typeof event === 'number') {
        return { type: event };
    }
    return event;
};
export var toActionObject = function (action) {
    var actionObject;
    if (typeof action === 'string' || typeof action === 'number') {
        actionObject = { type: action };
    }
    else if (typeof action === 'function') {
        actionObject = { type: action.name };
    }
    else {
        return action;
    }
    Object.defineProperty(actionObject, 'toString', {
        value: function () { return actionObject.type; }
    });
    return actionObject;
};
export var toActionObjects = function (action) {
    if (!action) {
        return [];
    }
    var actions = Array.isArray(action) ? action : [action];
    return actions.map(toActionObject);
};
export var raise = function (eventType) { return ({
    type: actionTypes.raise,
    event: eventType
}); };
export var send = function (event, options) {
    return {
        type: actionTypes.send,
        event: toEventObject(event),
        delay: options ? options.delay : undefined,
        id: options && options.id !== undefined ? options.id : getEventType(event)
    };
};
export var cancel = function (sendId) {
    return {
        type: actionTypes.cancel,
        sendId: sendId
    };
};
export var start = createActivityAction(actionTypes.start);
export var stop = createActivityAction(actionTypes.stop);
